module.exports = __webpack_public_path__ + "static/media/seed6.4e087c01.svg";